/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as Msdyn365 from '@msdyn365-commerce/core';

import { lAC_ITSGetOrderStatusAsync } from '../custom-actions/DataActionExtension.g';
import { IITSGetOrderStatusResponse, ILAC_AuthToken } from '../custom-actions/DataServiceEntities.g';
import { withFreshToken } from '../utils/authService';

/** What has become of an order, answered by the store from its own copy in one call. */
export class GetOrderStatusInput implements Msdyn365.IActionInput {
    public storeCartId: string;
    public channelId: number;
    public authTokenCookie: ILAC_AuthToken;

    constructor(storeCartId: string, channelId: number, authTokenCookie: ILAC_AuthToken) {
        this.storeCartId = storeCartId;
        this.channelId = channelId;
        this.authTokenCookie = authTokenCookie;
    }

    public getCacheKey = () => ['LACGETORDERSTATUS', this.channelId, this.storeCartId].join('_');
    public getCacheObjectType = () => 'LACGETORDERSTATUS';
    public dataCacheType = (): Msdyn365.CacheType => 'none';
}

async function getOrderStatusAsync(
    input: GetOrderStatusInput,
    ctx: Msdyn365.IActionContext
): Promise<IITSGetOrderStatusResponse | undefined> {
    if (!input.storeCartId || !input.authTokenCookie?.Token) {
        return undefined;
    }

    return withFreshToken(ctx, input.authTokenCookie, async carried =>
        lAC_ITSGetOrderStatusAsync({ callerContext: ctx }, carried, input.storeCartId, input.channelId)
    );
}

export default Msdyn365.createObservableDataAction({
    action: <Msdyn365.IAction<IITSGetOrderStatusResponse | undefined>>getOrderStatusAsync,
    id: 'GetOrderStatus'
});
